module.exports = __webpack_public_path__ + "img/pause.c609fec3.svg";